<form [formGroup]="articleForm" (ngSubmit)="onSubmit()"
  class="bg-[#f6f7fb] text-gray-600 rounded-[28px] shadow-2xl overflow-hidden">

  <!-- Header bar -->
  <div class="flex items-center justify-between w-full py-3 px-4 bg-gray-600 border-b border-gray-300 rounded-t text-white">
    <h2 class="text-lg font-semibold m-0">
      <ng-container *ngIf="hideSubmitButton; else editArticleTitle">
        Details of Failed Article
      </ng-container>
      <ng-template #editArticleTitle>
        Edit Article
      </ng-template>
    </h2>
    <button
      mat-icon-button
      aria-label="Close"
      class="hover:bg-gray-700 focus:outline-none rounded"
      (click)="closeDialog()"
      type="button"
    >
      <mat-icon class="!text-white !opacity-100">close</mat-icon>
    </button>


  </div>

  <!-- Body -->
  <div class="p-8 md:p-10">
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">

      <!-- Left: fields -->
      <div class="lg:col-span-2">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Title</mat-label>
          <mat-icon matPrefix>title</mat-icon>
          <input matInput formControlName="rss_title" class="text-gray-800 bg-transparent" />
          <mat-error *ngIf="articleForm.get('rss_title')?.hasError('required')">
            Article is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full mt-7">
          <mat-label>Description</mat-label>
          <mat-icon matPrefix>description</mat-icon>
          <textarea
            matInput
            formControlName="rss_description"
            rows="4"
            class="text-gray-800 bg-transparent"
          ></textarea>
          <mat-error *ngIf="articleForm.get('rss_description')?.hasError('required')">
            Description is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full rounded-xl bg-[#e6e9f1] mt-7" *ngIf="hideSubmitButton">
          <mat-label>Error Message</mat-label>
          <mat-icon matPrefix>error_outline</mat-icon>
          <textarea
            matInput
            formControlName="error_response_message"
            rows="3"
            class="text-gray-800 bg-transparent"
            readonly
          ></textarea>
        </mat-form-field>
      </div>

      <!-- Right: media preview + upload (same logic as your first form) -->
      <div class="lg:col-span-1" *ngIf="!isPhotolinkPost">
        <div class="text-sm font-semibold mb-3 text-gray-700">Preview</div>

        <!-- Preview container -->
        <div
          class="h-[230px] rounded-xl bg-white border border-gray-300 shadow-sm
                 flex items-center justify-center overflow-hidden"
        >
          <!-- Carousel -->
          <ng-container *ngIf="isCarouselPost && carouselImages.length > 0; else showOtherMedia">
            <div class="grid grid-cols-2 gap-2 w-full h-full p-3 overflow-y-auto">
              <img
                *ngFor="let img of carouselImages"
                [src]="img.src"
                [alt]="img.alt"
                class="object-cover rounded-lg shadow-sm w-full h-24"
              />
            </div>
          </ng-container>

          <!-- Single media -->
          <ng-template #showOtherMedia>
            <ng-container *ngIf="previewUrl; else noMedia">
              <img
                *ngIf="previewIsImage"
                [src]="previewUrl"
                alt="Preview"
                class="object-contain w-full h-full"
              />

              <video
                *ngIf="previewIsVideo"
                [src]="previewUrl"
                controls
                class="w-full h-full object-contain"
              >
                Your browser does not support the video tag.
              </video>
            </ng-container>
          </ng-template>

          <!-- Empty state -->
          <ng-template #noMedia>
            <span class="text-gray-400 italic">No media available</span>
          </ng-template>
        </div>

        <!-- Upload -->
        <div class="mt-6">
          <label
            *ngIf="!hideSubmitButton"
            class="items-center justify-center cursor-pointer
                   bg-blue-600 hover:bg-blue-700 text-white
                   rounded-md px-5 py-2 text-sm font-medium shadow-sm transition-colors"
          >
            Upload file
            <input type="file" (change)="onFileSelected($event)" accept="image/*,video/*" class="hidden" />
          </label>
        </div>
      </div>
    </div>

    <!-- Submit button -->
  <div class="flex flex-row justify-center mt-6">
    <button class="primary-btn" type="submit">
      Submit
    </button>
  </div>
  </div>
</form>